import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  currentInvoiceEstimate: association('invoice-estimate'),
  nextInvoiceEstimate: association('invoice-estimate'),
  nextBillingAt: faker.date.future(),
});
